import Image from './webp-image'
import React from 'react'

/**
 * @description Image Resizer component definition
 *      USAGE
 *          <ImageResized
 *              *** PROPS ***
 *          />
 *
 *      PROPS - these are required
 *          src         - path to displayed image
 *          size        - displayed size of image (https://bitbucket.org/astrumqinteractive/image-resizer/src/master/app/config/config.yml)
 *
 *      PROPS - these are optional
 *          defaultSrc  - default displayed image, if src prop is empty
 *
 */

/**
 * Returns file image name with parent folder
 * @param {string} path
 * @returns {string | *}
 */
const getImageSuffix = path => (
    path?.substr(path.lastIndexOf('/', path.lastIndexOf('/') - 1) + 1, path.length)
)

/**
 * Returns file image extension
 * @param {string} path
 * @returns {string | *}
 */
const getImageExtension = path => (
    path?.substr(path?.lastIndexOf('.') + 1, path?.length)
)

/**
 * Returns gallery thumbnail resized image
 * @param {string} key
 * @param {string} size
 * @param {number} ratio
 * @returns {string}
 */
const getResizedImage = (key, size, ratio = 1) => {
    if (!key) {
        return null
    }

    const { REACT_APP_IMAGE_RESIZER_URL } = window.APP_CONFIG
    const extension = getImageExtension(key)
    key = key?.split('.')[0]
    return `${REACT_APP_IMAGE_RESIZER_URL}${key}-${size}@${ratio}x.${extension}`
}

export const ImageResized = props => {
    const {
        src,
        size,
        ratio,
        ...restProps
    } = props

    const imageSrc = getResizedImage(getImageSuffix(src), size, ratio)

    return (
        <Image
            src={imageSrc}
            {...restProps}
        />
    )
}
